module.exports = __webpack_public_path__ + "img/app_logo.3ad39b37.png";